import { createMigration } from './utils';

export const migrationTo9_174 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('sceneGroups').forEach((sceneGroup, i) => {
                map.setIn(['sceneGroups', i], this.migrateSceneGroup(sceneGroup));
            });
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
            const template = map.get('template');
            map.set('template', this.migrateTemplate(template));
        });
    },
    migrateScene(scene) {
        return scene.withMutations(map => {
            const category = map.get('sceneCategory');
            if (category === 'talking_head' || category === 'talking_head_insert') {
                map.set('renderSlideImageMode', 'SceneMidpoint');
            }
        });
    },
});
